import React, { useState } from "react"
import BaseShapeRoundedRect from "./BaseShapeRoundedRect"
import * as common from "./common"
import { deepOrange } from "@mui/material/colors"
import ElementText from "./ElementText"
import Svg from "./Svg"
import { useFill } from "./useFill"

const ValueStream = (props) => {
    const { x, y, width, label, highlight, highlightColor, fillColor } = props

    const hoverColor = deepOrange[300]
    const defaultColor = fillColor || deepOrange[200]

    const [fill, setFill] = useState(defaultColor)

    const { handleFill } = useFill({ defaultColor, hoverColor, highlight, highlightColor, setFill })

    return (
        <Svg {...props} defaultColor={defaultColor} hoverColor={hoverColor} setFill={handleFill}>
            <BaseShapeRoundedRect {...props} fill={fill} setFill={handleFill} />

            <svg x={x} y={y}>
                <path
                    d={`M${width - 25},${6} ${common.markers["chevronRight"]} z`}
                    stroke={common.outlineColor}
                    fill='none'
                />
            </svg>

            <ElementText {...props} label={label} />
        </Svg>
    )
}

export default ValueStream
